import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  // Cambiar API
  constructor(private http: HttpClient) {}

  getRolesFunctions() {
    const url = `${AppSettings.API_URI_V2}/company-roles`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getCompanyUsers(idCompany: any, searchText?: any, role?: any) {
    let url = `${AppSettings.API_URI_V2}/companies/${idCompany}/users`;
    const params: string[] = [];

    if (searchText) {
      params.push(`search=${searchText}`);
    }
    if (role) {
      params.push(`role=${role}`);
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  getPermissionUser(idCompany, company_user_id: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${idCompany}/users/${company_user_id}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  savePermissionUser(company: number, user: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${company}/functions/users/${user}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  deleteUsersPermission(company: number, users: number[]) {
    const payload = {
      company_user_ids: users,
    };
    const url = `${AppSettings.API_URI_V2}/companies/${company}/functions/company-users`;
    return this.http.put(url, payload).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  deleteUsersPermissionDetail(company: number, userId: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${company}/functions/users/${userId}`;
        return this.http.delete(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }
}
